import { render, staticRenderFns } from "./TwoPlayer.vue?vue&type=template&id=ed419cf8&"
import script from "./TwoPlayer.vue?vue&type=script&lang=ts&"
export * from "./TwoPlayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports